module.exports = __webpack_public_path__ + "static/img/s2.cf70a76f.jpg";